import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 7.24a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM8.75 11a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z" />
      <path d="m18.25 3.63-4.5-2.6-2.06 2.25a7.53 7.53 0 0 0-1.38 0L8.25 1.03l-4.5 2.6.91 2.92c-.26.38-.5.78-.68 1.2L1 8.4v5.2l2.97.67a8.53 8.53 0 0 0 .7 1.2l-.92 2.9 4.5 2.6 2.06-2.25c.46.04.92.05 1.38 0l2.06 2.25 4.5-2.6-.91-2.92c.26-.38.5-.78.68-1.2L21 13.6V8.39l-2.97-.66-.3-.6-.01-.01c-.13-.21-.25-.4-.38-.58l.91-2.91Zm-5.98 1.23 1.77-1.93 2.42 1.4-.79 2.5.24.3c.2.26.36.49.5.73.15.26.27.53.38.8l.15.37 2.56.56v2.8l-2.56.57-.15.37c-.21.54-.5 1.05-.87 1.52l-.25.3.8 2.51-2.43 1.4-1.78-1.93-.4.06c-.56.09-1.15.08-1.74 0l-.39-.05-1.77 1.93-2.42-1.4.79-2.5-.24-.3a5.8 5.8 0 0 1-.88-1.53l-.15-.37-2.56-.57V9.6l2.56-.56.15-.37c.21-.54.5-1.05.87-1.52l.25-.3-.8-2.51 2.43-1.4 1.78 1.93.4-.06a6.03 6.03 0 0 1 1.74 0l.39.05Z" />
    </svg>
  </svg>
);
